<template>

    <section class="contenedor-slider-premios" id="premios">

        <div class="container">


            <h2 class="title">¿Qué puedes ganar?</h2>

            <slick ref="slick-slider4" :options="slickOptions" class="slider-premios">
                <div class="slide">
                    <div class="contenedor-imagen">
                        <img :src="`/static/img/momento-ganador/premios-2022/premio0.png`" alt="UN COCHE">
                        <p class="texto">con gastos pagados para dos personas</p>
                    </div>
                </div>
                <div class="slide">
                    <div class="contenedor-imagen">
                        <img :src="`/static/img/momento-ganador/premios-2022/premio1.png`" alt="VIAJES POR EUROPA">
                        <p class="texto">Disfruta al máximo este verano, consiguiendo entradas gratis a festis para ti y tus amigos
                        </p>
                    </div>
                </div>
           
                <div class="slide">
                    <div class="contenedor-imagen">
                        <img :src="`/static/img/momento-ganador/premios-2022/premio2.png`" alt="CONSOLA PLAYSTATION® 5">
                        <p class="texto">Equipa tus sesiones de juego con este conjunto de silla, pantalla, teclado, ratón y micro gaming</p>
                    </div>
                </div>
                <div class="slide">
                    <div class="contenedor-imagen">
                        <img :src="`/static/img/momento-ganador/premios-2022/premio3.png`" alt="SMARTPHONE">
                        <p class="texto">Disfruta de tu música favorita sin límites</p>
                    </div>
                </div>
                <!-- <div class="slide">
                    <div class="contenedor-imagen">
                        <img :src="`/static/img/momento-ganador/premios-2022/premio4.png`" alt="AURICULARES INALAMBRICOS">
                        <p class="texto">Aíslate del mundo exterior con estos auriculares</p>
                    </div>
                </div> -->
                <!-- <div class="slide">
                    <div class="contenedor-imagen">
                        <img :src="`/static/img/momento-ganador/premios-2022/premio5.png`" alt="CHEQUE REGALO">
                        <p class="texto">Para disfrutar la mejor música en cualquier sitio</p>
                    </div>
                </div> -->
                <!-- <div class="slide">
                    <div class="contenedor-imagen">
                        <img :src="`/static/img/momento-ganador/premios-2022/premio6.png`" alt="CRÉDITO PLAYSTATION® STORE">
                        <p class="texto">Elige entre miles de juegos de PlayStation, suscripciones y más beneficios</p>
                    </div>
                </div> -->
                <div class="slide">
                    <div class="contenedor-imagen">
                        <img :src="`/static/img/momento-ganador/premios-2022/premio7.png`" alt="PRODUCTO GRATIS">
                        <p class="texto">Para canjear por tus productos favoritos</p>
                    </div>
                </div>
                <!-- <div class="slide">
                    <div class="contenedor-imagen">
                        <img :src="`/static/img/momento-ganador/premios-2022/premio9.png`" alt="PRODUCTO GRATIS">
                        <p class="texto">Cualquier lugar es bueno para disfrutar de tus juegos favoritos con esta Nintendo Swich Lite</p>
                    </div>
                </div> -->

                

            </slick>

        </div>




    </section>

</template>

<script>

    import Slick from 'vue-slick';

    export default {
        name: "slider-premios",
        data() {
            return {
                slickOptions: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    adaptiveHeight: false,
                    draggable: true,
                    infinite: true,
                    centerMode: true,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                infinite: true,
                            }
                        },
                        {
                            breakpoint: 769,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                centerMode: false,
                            }
                        }
                    ]
                },
            }
        },
        components: {
            Slick
        }
    }

</script>


// WEBPACK FOOTER //
// src/components/view-parts/momento-ganador/slider-premios.vue